// Libs
import ApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { useState, useMemo } from "react";
// Types
import { ChartSetEight } from "../Libs/Types/ChartTypes";
// Utils
import {
  CHART_AXIS_FALLBACK,
  chartColors,
  chartHeight,
} from "../Libs/Utils/utils";
// UI-Components
import ChartFallBack from "../UI-Components/ChartFallback";

export default function BubbleChart({
  chartData,
  dataKey,
}: {
  chartData: ChartSetEight["BubbleChart"];
  dataKey: string;
}) {
  // Assign a unique color to this chart instance ONCE
  const [chartColor] = useState(() => chartColors);
  // If you have multi-series, you can generate a list of random colors ONCE per chart
  const colorList = useMemo(() => {
    if (!chartData || !Array.isArray(chartData)) return [];
    return chartData.map(() => chartColors);
  }, [chartData]);
  const option: ApexOptions = {
    chart: {
      fontFamily: "Poppins",
      toolbar: {
        show: true,
      },
    },
    title: {
      align: "left",
      text:
        chartData !== undefined
          ? chartData["title"]
          : CHART_AXIS_FALLBACK["title"],
      style: { fontSize: "14px", fontWeight: "900" },
    },
    legend: {
      show: false,
    },
    xaxis: {
      tickAmount: 12,
      type: "category",
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    yaxis: {
      // max: 70
      labels: {
        style: {
          fontSize: "8px",
        },
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "8px",
      },
    },
    fill: {
      colors: colorList.length > 0 ? colorList : [chartColor], // Use colorList for multi-series, or chartColor for single
      opacity: 0.6,
    },
    colors: colorList.length > 0 ? colorList : [chartColor], // Also set here for line/area color[2][3]
  };

  const series: any =
    chartData !== undefined && Array.isArray(chartData["data"]) === true
      ? chartData["data"]
      : undefined;

  return (
    <div className="my-2 chartWrp border-1 rounded-lg w-full">
      {series !== undefined ? (
        <ApexChart
          type="bubble"
          options={option}
          series={series}
          height={chartHeight}
          width={"100%"}
          key={dataKey}
        />
      ) : (
        <ChartFallBack />
      )}
    </div>
  );
}
